import { render } from "./padresevento_ingles.vue?vue&type=template&id=cbc62f4e&scoped=true"
import script from "./padresevento_ingles.vue?vue&type=script&lang=js"
export * from "./padresevento_ingles.vue?vue&type=script&lang=js"

import "./padresevento_ingles.vue?vue&type=style&index=0&id=cbc62f4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbc62f4e"]])

export default __exports__